import { Component, Input } from '@angular/core';
import { NavController } from 'ionic-angular';

import { ConfigProvider } from '../../providers/config/config';
import { EventsProvider } from '../../providers/events/events';
import { LocationsProvider } from '../../providers/locations/locations';
import { CoEventDetailsComponent } from '../co-event-details/co-event-details';

import moment from 'moment';
import { AppState } from '../../config/state';


/**
 * Generated class for the CoRoamEventlistComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-roam-eventlist',
  templateUrl: 'co-roam-eventlist.html',
  inputs: ['selectedBranch, branchList']
})
export class CoRoamEventlistComponent {
  private selectedEvent: any;
  private todaysDate: string = '';
  private hideRegistrantList: boolean = false;

  private checkedIn: number = 0;
  private numberOfRegistrants: number = 0;

  @Input('selectedBranch') selectedBranch;
  private selectedBranchId: number;
  private eventTimes: Array<any>;
  private registrantList: any;
  @Input('branchList') branchList: Array<any>;

  private textFilter: string = '';
  private filteredTimes: Array<any>;

  constructor(private config: ConfigProvider, private eventsProvider: EventsProvider, private location: LocationsProvider, public navCtrl: NavController, private state : AppState) {
    this.todaysDate = moment().format("dddd MMMM Do, YYYY");
  }

  ngOnInit() {
    if(this.selectedBranch === undefined){
      this.selectedBranch = {
        id: -1,
        name: '',
        miles: 0,
        feet: 0,
        meters: 0
      };
    }

    this.selectedBranchId = this.selectedBranch.id;
    this.eventTimes = [];
  }

  ionViewDidLoad() {
    // console.log('branch list', this.branchList);
    this.showEvents();
  }

  branchSelector(){
    this.location.getLocations().then((locations) => {
      locations.forEach((location) => {
        this.branchList.push({
          title: location.name,
          id: location.id
        });
      });
    }, (err) => {
      this.branchList.push({
        name: 'No Locations Available',
        id: -1
      })
    });
  }

  filterEvents() {
    if(this.textFilter.length > 0){
      if(this.eventTimes.length > 0){
        this.filteredTimes = this.eventTimes.filter((time) => {
          let foundAges = time.ages.filter((age) => {
            return (age.indexOf(this.textFilter) > -1)
          });

          let foundTypes = time.types.filter((type) => {
            return (type.indexOf(this.textFilter) > -1);
          });

          let titleCheck = time.title.indexOf(this.textFilter) > -1;
          let subTitleCheck = time.subTitle.indexOf(this.textFilter) > -1;
          let descCheck = time.description.indexOf(this.textFilter) > -1;

          if((foundAges > 0) || (foundTypes > 0) || titleCheck || subTitleCheck || descCheck){
            return time;
          }
        });
      }
    }
  }

  loadRegistrants(event){
    // console.log('evt', event);
    this.checkedIn = 0;
    this.numberOfRegistrants = 0;
    this.selectedEvent = event;
    this.eventsProvider.getEventRegistrants(event.eventId).then((registrants) => {
      // console.log('registrants', registrants);
      this.registrantList = registrants;
      this.hideRegistrantList = false;

      this.registrantList.forEach((registrant) => {
        if(registrant.patronCheckedIn){
          this.checkedIn++;
        }
        this.numberOfRegistrants++;
      });
    });
  }

  loadEventDetail(eventId) {
    this.config.load(this.state.appId).then(cfg => {
      this.navCtrl.push(CoEventDetailsComponent, { eventId: eventId, searchTags: "", showRegistrants: true });
    });
  }

  showEvents() {
    let startDate: string = moment().format("YYYY-MM-DD");
    let endDate: string = startDate;
    // console.log('branches', this.branchList);
    let locId: number = this.selectedBranchId;
    this.eventTimes = [];
    // Taking out :locationId: ${locId}
    // This is for debug only

    // console.log('locId', locId);
    this.eventsProvider.getEvents(`startDate: "${startDate}", endDate: "${endDate}", locationId: ${locId}`).then((eventData) => {
      let hours = [];

      // console.log('ae', eventData);

      eventData.allEvents.forEach((event)=>{
        let evtH = moment(event.eventStart).format("HHmm");
        if(!hours[evtH]){
          hours[evtH] = [];
        }

        event.eventImage = "https://cuyahogademo.libnet.info/images/events/cuyahogademo/" + event.eventImage;
        event.eventTimes = moment(event.eventStart).format("h:mma") + " - " + moment(event.eventEnd).format("h:mma");
        hours[evtH].push(event);
      });

      // console.log('hours', hours);

      for(let hour in hours){
        let events = [];
        let formattedHour = '';
        for(let h=0;h<hours[hour].length;h++){
          if(formattedHour === ''){
            formattedHour = moment(hours[hour][h].eventStart).format("hh:mma");
          }
          events.push(hours[hour][h]);
        }

        this.eventTimes.push({
          "time": formattedHour,
          "events": events,
          "open": true
        });
      };

      // Save a copy off for filtering
      this.filteredTimes = this.eventTimes;
      // console.log('eventTimes', this.eventTimes);
    });
  }

  toggleSection(i){
    // console.log(this.eventTimes[i].open)
    this.eventTimes[i].open = !this.eventTimes[i].open;
  }

  updateCheckIn(registrantIndex) {
    let registrant: any = null;
    if(registrantIndex >= 0){
      registrant = this.registrantList[registrantIndex];
    }
    registrant.checkedIn = registrant.checkedIn ? 1 : 0;
    if(registrant.checkedIn){
      this.checkedIn++;
    }

    let checkInObj = {
      registrationId: registrant.registrationId,
      checkedIn: registrant.patronCheckedIn
    };
    this.registrantList[registrantIndex].checkedIn = registrant.checkedIn;
  }
}



// WEBPACK FOOTER //
// ./src/components/co-roam-eventlist/co-roam-eventlist.ts